import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@elparking/components'

import VehicleInspectionProduct from 'vehicle-inspection-product-selector/js/components/VehicleInspectionProduct'
import { Events, trackEvent } from 'commons/js/services/analytics'
function VehicleInspectionProductsList ({products, selectedProduct, onClick, trackEvent}) {
    return (
        <Box as='ul'>
            {products.map((product) => (
                <Box
                  as='li'
                  key={product.id}
                  w='100%'
                  mb='8px'
                  onClick={() => {
                      onClick(product)
                      trackEvent(Events.vehicleInspectionStationSelectProduct, product.idVehicleInspectionProduct)
                  }}
                >
                    <VehicleInspectionProduct
                      product={product}
                      isSelected={product.id === selectedProduct.id}
                    />
                </Box>
            ))}
        </Box>
    )
}

VehicleInspectionProductsList.defaultProps = {
    onClick: () => {},
    products: [],
    selectedProduct: {},
    trackEvent,
}

VehicleInspectionProductsList.propTypes = {
    selectedProduct: PropTypes.object,
    products: PropTypes.array,
    onClick: PropTypes.func,
    trackEvent: PropTypes.func,
}

export default VehicleInspectionProductsList
